export default function Container({...props}) {
    //UI
    return (
      <div>
        {props.children}
      </div>
    );
  }